/**
 * Coups de pouce — Attendu 640 « Connaître la formule du périmètre d'un
 * disque ».
 *
 * Une entrée par `generator_key` (cf. gen_640.js). Doctrine « pur rappel »
 * (actée 2026-07-31) : les QCM unique et multiple n'ont PAS d'entrée — la
 * connaissance demandée EST la réponse, toute aide utile la donnerait.
 * Le relier, lui, garde un travail résiduel (départager la vraie formule de
 * ses leurres), donc une aide de MÉTHODE se défend : lire une formule, jamais
 * la donner.
 */

const CP_640 = {
    // Format saisie (chaîne formule → substitution → calcul) : l'aide attaque
    // LE piège du format (confondre R et D) et montre le geste sur des valeurs
    // HORS pools (R = 20 : rayons ≤ 12, et D = 40 impossible côté diamètres).
    formule_perimetre_texte_trou_saisie: {
        pages: [
            {
                titre: 'Remplacer la lettre',
                lignes: [
                    'Dans la formule, remplace la **lettre** par **sa** valeur : R par le rayon, D par le diamètre. Le rayon et le diamètre ne sont **pas** interchangeables.',
                    'Puis calcule le produit avec **π ≈ 3,14**.',
                ],
            },
            {
                titre: 'Un exemple',
                lignes: [
                    'Rayon R = **20** cm : P = 2 × π × R.',
                    'On remplace : P ≈ 2 × 3,14 × **20** ≈ **125,6** cm.',
                ],
            },
        ],
    },

    formule_perimetre_relier: {
        pages: [
            {
                titre: 'Lire une formule',
                lignes: [
                    'Dans une formule, la lettre placée **avant le signe =** est ce qu\'on **calcule**. Les lettres placées **après** sont ce qu\'on **connaît**.',
                    'Pour chaque situation, repère ce qu\'on **connaît** et ce qu\'on **cherche**, puis élimine les formules qui ne correspondent pas. Attention : certaines formules de la liste sont **fausses**.',
                ],
            },
        ],
    },
};

export default CP_640;
